import { createStore } from 'vuex'

export default createStore({
  state: {
    codigo: '',       // codigo del inversionista, segun su documento de acceso
    correo: '',       // cuenta de Google con la que entro
    nombre: '',
    comunidadNombre: ''
  },

  mutations: {
    setSesion (state, payload) {
      state.codigo = payload.codigo
      state.correo = payload.correo || state.correo
      state.nombre = payload.nombre || ''
      // El nombre de la comunidad llega despues, al cargar el estado de cuenta
      if (payload.comunidadNombre) state.comunidadNombre = payload.comunidadNombre
    },

    cerrarSesion (state) {
      state.codigo = ''
      state.correo = ''
      state.nombre = ''
      state.comunidadNombre = ''
    }
  }
})
